<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="Lapor Sijil Lahir">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis" label="ID Premis" />
              <!-- <z-select style="margin:5px; " v-model="pencarian.jantina" :items="jantina" label="Jantina" /> -->
              <!-- <z-select style="margin:5px; " v-model="pencarian.lkp_baka_id" :items="lkp_baka" label="Baka" /> -->
              <!-- <z-select style="margin:5px; " v-model="pencarian.lkp_kaedah_kelahiran_id" :items="lkp_kaedah_kelahiran" label="Kaedah Kelahiran" /> -->
              <z-select style="margin:5px; " v-model="pencarian.lkp_status_anak_id" :items="lkp_status" label="Status" />
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
        <z-table title="Senarai Lapor Sijil Lahir" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
            <template #button v-if="$zutil.role('2') || $zutil.role('1') || $zutil.role('5')">
                <w-button dark class="green--bg ml1" :route="$route('art.anak.form',0)" >
                    <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
                </w-button>
            </template>
          <template #header-label="{ header, label, index }">
            <template v-if="header.key == 'action'">
              <!-- <w-icon xs>fal fa-pencil</w-icon> -->
              Tindakan
            </template>
            <template v-else>
              {{ label }}
            </template>
          </template>
          <template #item-cell.action="{ item, label, header, index }">
            <w-flex class="flex justify-center">
               <!--  <w-button bg-color="success" class="mr3" @click="cetak(item.id)" v-if="item.lkp_art_id == 1 || item.lkp_art_id == 3">
                        <w-icon>fal fa-print</w-icon>&nbsp;CETAK
                </w-button> -->
              <inertia-link :href="$route('art.anak.show',item.id)" class="w-button w-button--dark size--md info-dark1--bg" v-if="item.lkp_status_anak_id != 19 ">
                <w-icon xs class="mr2">fal fa-eye</w-icon>  PAPAR
              </inertia-link>
               &nbsp;  
              <inertia-link :href="$route('art.anak.form',item.id)" class="w-button w-button--dark size--md warning--bg" v-if="!$zutil.anyRole(['4']) && item.lkp_status_anak_id == 19"> 
                <w-icon xs class="mr2">fal fa-pencil</w-icon>  KEMASKINI
              </inertia-link>
            </w-flex>
          </template>
        </z-table>
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    segmenName: [Array, Object]
  },
  data() {
  return {
    resourceurl: 'baka.anak',
    crumbs: [
      { label: this.$page.props.app_name, route: '/home' },
      { label: 'Pensijilan Ternakan Baka', route: '/baka' },
      { label: 'Sijil Lahir', route: '/art/' + this.segmenName },
    ],

    form: {}, // 👈 JANGAN guna this.d_form

    pencarian: {
      premis_id: '',
      lkp_status_anak_id: '',
    },
    premis: [],
    lkp_status: [],
  }
},
  methods: {
   capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
   },
  cari() {
    if (!this.valid) return;

    this.$inertia.get(route('baka.anak.index'),
      {
        ...this.pencarian,
        page: 1,
      },
      {
        preserveState: true,
        preserveScroll: true,
      }
    );
  },

    resetPencarian() {
       this.$inertia.get(route('baka.anak.index'));
     },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_anak', {}).then(res => {
        this.lkp_status = res
      })
    },

    getPremis(){
     this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
       this.premis = res
     })
   },

  

    // getKaedahKelahiran(){
    //   this.$zcomm.get(this.api_service + 'lookup/kaedah_kelahiran', {}).then(res => {
    //     this.lkp_kaedah_kelahiran = res
    //   })
    // },

    // getBaka(){
    //   this.$zcomm.get(this.api_service + 'lookup/baka_all', {}).then(res => {
    //     this.lkp_baka = res
    //   })
    // },

    // getJantina(){
    //   this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
    //     this.jantina = res
    //   })
    // },

     cetak(id)
        {
          window.open('anak/cetak/'+id);
        },

    
  
  },

  watch: {

  },
  mounted() {
   this.getStatus();
   this.getPremis();
   // this.getBaka();
   // this.getJantina();
   // this.getKaedahKelahiran();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
